import { render, staticRenderFns } from "./ClientEmailsTable.vue?vue&type=template&id=64bc31ac&scoped=true&"
import script from "./ClientEmailsTable.vue?vue&type=script&lang=js&"
export * from "./ClientEmailsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bc31ac",
  null
  
)

export default component.exports